
//import '../../App.scss';
// import "../SignIn/SignIn.scss";
import SignInFooter from "../../components/SignIn/SignInFooter";
import LeftImage from "../../components/SignIn/LeftImage";
import ResetPasswordForm from "../../components/ResetPassword/ResetPasswordForm";


const ResetPassword = () => {

  return (
    <div className="login-ary">
      <section className="login-sec ">
        <div className="login-container ">
          <div className="container-fluid">
            <div className="row bglogin">
              <LeftImage />
              <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt">
               <ResetPasswordForm />
                <SignInFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
